module.exports = __webpack_public_path__ + "static/perfect_packaging-164ae3f2289eb12cfe95a61edfd90731.jpg";